import { Box, CircularProgress, Container, Stack } from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EmployeeBasicInfo from '../components/EmployeeBasicInfo';
import Page from '../components/Page';

import PageHeader from '../components/smallComponents/PageHeader';
import ProjectEngineerDetailPageTabs from '../components/cardTabs/ProjectEngineerDetailPageTabs';

export default function ViewProjectEngineer() {
  const { accType } = useSelector((state) => state.user.userInfo);
  const admin = accType === 'SUPER_ADMIN' || accType === 'SUB_ADMIN';

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [employee, setEmployee] = useState({});

  const getEmployee = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/member/project-engineer`, {
        params: {
          id,
        },
      });
      console.log('employee', res);
      setEmployee(res.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmployee();
  }, [id]);

  return (
    <Page title="Project Engineer">
      {isLoading ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItem: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Container maxWidth="xl">
          <PageHeader title="Project Engineer" />
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Box id="basic-info" marginBottom={1}>
              <EmployeeBasicInfo getEmployee={getEmployee} employee={employee} />
            </Box>
            <Box id="basic-info" marginBottom={1}>
              <ProjectEngineerDetailPageTabs projectEngineer={employee} />
            </Box>
          </Stack>
        </Container>
      )}
    </Page>
  );
}
